<div class="card-section">
    <div class="">
        <div class="card-section-header flex items-center justify-between mb-3">
            <h5 class="card-section-title text-lg">
                <span class="animate-pulse font-semibold" style="color: #d16f32;">{{ unitTypeName() }} :</span><span
                    *ngIf="managedUnitName()">
                    {{ managedUnitName() }}</span>
                <!--{{ officeName() }}-->
                <!--span class="ml-1">({{ userRole() }})</span-->
            </h5>
            <div>
                <h5><b style="color: #d16f32;">User Role :</b> {{ userRole() }}</h5>
            </div>
        </div>
        @if(isDistrictOrStateOffice()) {
        <div class="grid grid-cols-4 md:grid-cols-4 gap-3">
            <mat-card>
                <div class="dashBoard-card">
                    <div class="">
                        <img src="../../../../assets/images/img-status-4.svg" alt="img" class="img-fluid img-bg">
                        <div class="card-content">
                            <div class="subtitle">
                                <h6 class="" class="mb-0">Total SHG</h6>
                            </div>
                            <div>
                                <h3 class="title" style="color:#d16f32!important;">{{ totalShg() }}</h3>
                            </div>
                            <p class="card-para">Total number of SHG in West Bengal</p>
                        </div>
                    </div>
                </div>
            </mat-card>
            <mat-card>
                <div class="dashBoard-card">
                    <div class="">
                        <img src="../../../../assets/images/img-status-4.svg" alt="img" class="img-fluid img-bg">
                        <div class="card-content">
                            <div class="subtitle">
                                <h6 class="" class="mb-0">Total Sangha</h6>
                            </div>
                            <div class="">
                                <h3 class="title" style="color:#d16f32!important;">{{ totalSangha() }}</h3>
                            </div>
                            <p class="card-para">Total number of sangha in West Bengal</p>
                        </div>
                    </div>
                </div>
            </mat-card>
            <mat-card>
                <div class="dashBoard-card">
                    <div class="">
                        <img src="../../../../assets/images/img-status-4.svg" alt="img" class="img-fluid img-bg">
                        <div class="card-content">
                            <div class="subtitle">
                                <h6 class="" class="mb-0">Total Upasangha</h6>
                            </div>
                            <div class="">
                                <h3 class="title" style="color:#d16f32!important;">{{ totalUpasangha() }}</h3>
                            </div>
                            <p class="card-para">Total number of upasangha in West Bengal</p>
                        </div>
                    </div>
                </div>
            </mat-card>
            <mat-card>
                <div class="dashBoard-card">
                    <div class="">
                        <img src="../../../../assets/images/img-status-4.svg" alt="img" class="img-fluid img-bg">
                        <div class="card-content">
                            <div class="subtitle">
                                <h6 class="" class="mb-0">Total CMTC</h6>
                            </div>
                            <div class="">
                                <h3 class="title" style="color:#d16f32!important;">{{ totalCmtc() }}</h3>
                            </div>
                            <p class="card-para">Total number of CMTC in West Bengal</p>
                        </div>
                    </div>
                </div>
            </mat-card>
        </div>
        }
    </div>
</div>